import React from 'react';

const Enquiries = () => {
  return (
    <div className="container mt-5">
      <h2>Enquiries Management</h2>
      <p>Contact enquiries list will be displayed here</p>
    </div>
  );
};

export default Enquiries;
